<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <div
    class="flex h-full items-center border-b-2 transition-all duration-700 ease-in-out hover:border-static-default-hi"
    :class="[
      isActivePage(url) && !isMenuActive
        ? 'border-static-default-hi'
        : 'border-transparent',
    ]"
    role="none"
  >
    <RevLink
      :aria-expanded="String(activeMenu === id)"
      :aria-haspopup="String(hasPopup)"
      class="bold-hack border-static-default-low text-action-default-low box-content inline-block rounded-none transition-all duration-700 ease-in-out hover:body-2-bold hover:no-underline"
      :class="[isActivePage(url) && !isMenuActive ? 'body-2-bold' : 'body-2']"
      role="menuitem"
      :style="{ color }"
      :title="title"
      :to="url"
      :underlined="false"
    >
      <span class="flex h-full flex-nowrap items-center gap-4">
        <component :is="icon" v-if="icon" />
        <span>{{ title }}</span>
      </span>
    </RevLink>
    <div v-if="hasPopup" v-show="activeMenu === id" aria-label="submenu">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'

import { RevLink } from '@ds/components/Link'

import { useNavigation } from '../../composables/useNavigation'

defineProps<{
  url: string
  id?: number
  color?: string
  title: string
  icon?: string | object
}>()

const slots = useSlots()
const hasPopup = computed(() => !!slots.default)

const { isMenuActive, activeMenu, isActivePage } = useNavigation()
</script>

<style scoped>
.bold-hack::after {
  display: block;
  content: attr(title);
  font-weight: 600;
  font-size: 0.875rem /* 14px */;
  line-height: 1.25rem /* 20px */;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  contain: content;
}
</style>
